<template>
<div class="chapter">
<div class="inner_page">
<p class="subtitle" id="title"><span class="small"><span class="gray"><strong>BUILDING A LEADERSHIP CULTURE</strong></span></span></p>
<h1 class="h1">LEADERS<br/>MADE<br/>HERE</h1>
<p class="author"><span class="gray"><strong>MARK MILLER</strong></span></p>
<p class="edit">Bestselling author of <em>Chess Not Checkers</em> and <em>The Heart of Leadership</em></p>
<p class="pub"><img alt="Images" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?6af2758a